<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}:{{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" :busy="isBusy" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Visualizza storico letto" @click="onView(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="info"> </font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            filtroStoricoPostiLetto: {},
            pathResource: "/rsapostilettoaccettazione/storico",
            showModalLoading: false,
            show: true,
            perPage: 50,
            currentPage: 1,
            allItems: [],
            rows: 0,
            rowsUsers: 0,
            listKey: 0,
            isBusy: false,
            items: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                { label: "Nome letto", key: "nomeLetto", sortable: true },
                { label: "Nome stanza", key: "nomeStanza", sortable: true },
                { label: "Nome piano", key: "nomePiano", sortable: true },
                { label: "Sesso", key: "sesso" },
                { label: "Tipo letto", key: "tipoLetto" },
                { label: "Descrizione reparto", key: "descrizioneReparto" },
                { label: "Numero cartella", key: "numeroCartella" },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroStoricoPostiLetto = sessionStorage.getItem("filtroStoricoPostiLetto");
            if (filtroStoricoPostiLetto) {
                me.filtroStoricoPostiLetto = JSON.parse(filtroStoricoPostiLetto);
            }
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroStoricoPostiLetto, me.loadDataStoricoPostiLettoSuccess, me.loadDataStoricoPostiLettoError);
        },
        loadDataStoricoPostiLettoSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataStoricoPostiLettoError(error) {
            let me = this;
            console.log("Errore nel caricamento dei StoricoPostoLetto:", error);
            me.$emit("afterLoadData");
        },
        onRefresh() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroStoricoPostiLetto = sessionStorage.getItem("filtroStoricoPostiLetto");
            if (filtroStoricoPostiLetto) {
                me.filtroStoricoPostiLetto = JSON.parse(filtroStoricoPostiLetto);
            }
            me.loadData(me.filtroStoricoPostiLetto);
        },
        onView(item) {
            this.$router.push("/rsastoricopostoletto/view/" + item.idLetto);
        },
        onDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare questo StoricoPostoLetto: " + item.tipo, {
                    title: "Conferma eliminazione",
                    size: "sm",
                    okVariant: "danger",
                    okTitle: "Elimina",
                    cancelTitle: "Annulla",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteStoricoPostoLetto(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>
